import { AxiosResponse } from 'axios'

import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { AggregationPipeline } from 'types/common/aggregation'
import { api, handleError } from 'API'
import { IDocumentType } from 'interfaces/documentType'

export async function getDocumentTypesByAggregate(pipeline: AggregationPipeline): Promise<IDocumentType[]> {
  try {
    const response: AxiosResponse = await api.post(`/document-types/aggregate`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function getDocumentTypes(filter: IFilter<IDocumentType>): Promise<IDocumentType[]> {
  try {
    const response = await api.get(`/document-types?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/documentType.ts', 'getDocumentTypes', false, true)
    return []
  }
}

export async function getDocumentTypeDetail(id: string, filter: IFilter<IDocumentType>): Promise<IDocumentType> {
  try {
    const response = await api.get(`/document-types/${id}?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/documentType.ts', 'getDocumentTypeDetail')
    return {}
  }
}

export async function countDocumentTypes(where: Where<IDocumentType> = {}): Promise<number> {
  try {
    const { data = 0 } = await api.get(`/document-types/count?where=${JSON.stringify(where)}`)
    return Number(get(data, 'count', 0))
  } catch (error: any) {
    handleError(error as Error, 'API/documentType.ts', 'countDocumentTypes')
    return 0
  }
}

export async function createDocumentType(userData: IDocumentType): Promise<IDocumentType> {
  try {
    const response = await api.post(`/document-types`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/documentType.ts', 'createDocumentType')
    return {}
  }
}

export async function updateDocumentType(id: number, userData: IDocumentType): Promise<IDocumentType> {
  try {
    const response = await api.patch(`/document-types/${id}`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/documentType.ts', 'updateDocumentType')
    return {}
  }
}

export async function deleteDocumentType(id: number): Promise<void> {
  try {
    const response = await api.delete(`/document-types/${id}`)
    return response.data
  } catch (error: any) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/documentType.ts', 'deleteDocumentType')
    throw new Error(errorMessage)
  }
}
